
// React Imports
import * as React from "react";
import {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import {
    DataGrid,
    GridToolbarColumnsButton,
    GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport,
    GridToolbarFilterButton
} from '@mui/x-data-grid';
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Box from "@mui/material/Box";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { ListItemIcon, ListItemText, Menu,
    Tooltip
} from "@mui/material";

// App Imports

import {deleteDataPointValue, getAllDataPointValues} from "./DataPointValueClient";
import {changeDataPointValue} from "../DataPointValue/dataPointValueSlice";
import ContractSectionMenu from "../Menus/ContractSectionMenu";
import DataPointValueDrawer from "../DataPointValue/DataPointValueDrawer";
import CustomFooter from "../CommonComponents/GridCustomFooter";
import {changeCrudSnackbar} from "../CommonComponents/crudSnackbarSlice";
import CrudSnackbar from "../CommonComponents/CrudSnackbar";
import {CheckBox} from "@mui/icons-material";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AddFiltersExportToolbar from "../CommonComponents/AddFiltersExportToolbar";
import {DataPointAttributeGridColumns} from "../DataPointAttribute/DataPointAttributeGridColumns";
import {changeDataPointAttribute} from "../DataPointAttribute/dataPointAttributeSlice";
import {DataPointValueGridColumns} from "./DataPointValueGridColumns";
import DpvInfoDialogue from "./Info/DpvInfoDialogue";

// main function
export default function DataPointValueGrid() {

    // ****************** BEGIN STATES ****************************

    const [dataPointValues, setDataPointValues] = useState([]);
    const [deleteOpen, setDeleteOpen] = React.useState(false);
    const [gridVisible, setGridVisible] = React.useState(true);
    const [showControls, setShowControls] = useState(true);
    const [showCRUD, setShowCRUD] = useState(true);
    const [dpvInfoOpen, setDpvInfoOpen] = useState(false);

    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************

    const selectorDataPointValueId = useSelector((state) => state.dataPointValueSlc.value.id);
    const selectorDataPointValueMcode = useSelector((state) => state.dataPointValueSlc.value.mcode);
    const selectorDataPointValueName = useSelector((state) => state.dataPointValueSlc.value.name);
    const selectorDataPointValueDescription = useSelector((state) => state.dataPointValueSlc.value.description);
    const selectorDpfDrawerState = useSelector((state) => state.dataPointValueSlc.value.dpvDrawerState);
    const hideActions = localStorage.getItem('hideActions') === "true";
    const dispatchData = useDispatch();

    const selectorDpvDrawerState = useSelector(state => state.dataPointValueSlc.value.dpvDrawerState);
    const selectorDpvGridRefresh = useSelector(state => state.dataPointValueSlc.value.dpvGridRefresh);
    // ********************** END STORE ********************************


    // ****************** BEGIN FETCH ****************************


    // useEffect(() => {
    //     fetchDataPointValues();
    // }, [useSelector((state) => state.dataPointValueSlc.value.dpvDrawerState)]);

    const fetchDataPointValues = React.useCallback(() => {
        return getAllDataPointValues()

            .then(data => {
                console.log(data);
                setDataPointValues(data);
            });
    }, []);

    useEffect(() => {
        fetchDataPointValues();
    }, [selectorDpvDrawerState, fetchDataPointValues]);

    useEffect(() => {
        if (!selectorDpvGridRefresh) return;

        fetchDataPointValues().finally(() => {
            dispatchData(changeDataPointValue({ dpvGridRefresh: false }));
        });
    }, [selectorDpvGridRefresh, fetchDataPointValues, dispatchData]);

    // ****************** END FETCH ****************************

    // useEffect(() => {
    //     fetchDataPointValues();
    //     dispatchData(changeDataPointValue({dpvGridRefresh: false}));
    // }, [useSelector((state) => state.dataPointValueSlc.value.dpvGridRefresh)===true]);
    //


    // ****************** BEGIN CRUD ***********************************

    const handleAdd = () => {
        dispatchData(changeDataPointValue({id: 0, mcode: "", name: "", description: "", dataPointId: null,
            dpvDrawerState: true, dpvDrawerMode: "Add"
            }));

    };

    const removeDataPointValue = ( ) => {
        deleteDataPointValue(selectorDataPointValueId).then(() => {
            setDeleteOpen(false);
            dispatchData(changeDataPointValue({dpvGridRefresh: true}));
            dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record deleted"}));
        })
    }

    // ****************** END CRUD ***********************************


    const handleClickedRow = (dataPointValues) => {

        console.log('Value data from clicked row');
        console.log(dataPointValues);
        dispatchData(changeDataPointValue({id: dataPointValues.id, dataPointId: dataPointValues.dataPointId,
            mcode: dataPointValues.mcode, name: dataPointValues.name, ordinalNumber: dataPointValues.ordinalNumber,
            description: dataPointValues.description,     exceptionInd: dataPointValues.exceptionInd}));
    };


    const handleDpvInfo = () => {
        setDpvInfoOpen(true);
    };

    const handleCloseDpvInfo = () => {
        setDpvInfoOpen(false);
    };





    // ****************** BEGIN RETURN ****************************

    return (
        <div style={{ height:800 , width: '100%' }}>
            <Box sx={{height: 70, pt: 1, pl: 3}}>
                <Tooltip enterDelay={1000} enterNextDelay={1000} title={"Click for information."}>
                <h3
                    style={{cursor:'pointer'}}   onClick={() => handleDpvInfo()}
                >Data Point Values</h3>
                </Tooltip>
            </Box>
            <DpvInfoDialogue
                open={dpvInfoOpen}
                onClose={handleCloseDpvInfo}
            />
            {showCRUD && <ContractSectionMenu/>}
            {useSelector((state) => state.dataPointValueSlc.value.dpvDrawerState) &&
            <DataPointValueDrawer
                fetchDataPointValues = {fetchDataPointValues}
            />}
            {gridVisible && <DataGrid
                experimentalFeatures={{ newEditingApi: true }}
                initialState={{
                }}
                aria-label={"DataPointValues"}
                rows={dataPointValues}
                disableDensitySelector={true}
                disableColumnSelector={true}
                onRowClick = {(dataPointValues)=>handleClickedRow(dataPointValues.row)}
                columns={DataPointValueGridColumns({
                    hideActions,
                    // handleMousedRow,
                    onEdit: () => dispatchData(changeDataPointValue({ dpvDrawerState: true, dpvDrawerMode: "Edit" })),
                    onClone: () => dispatchData(changeDataPointValue({ dpvDrawerState: true, dpvDrawerMode: "Clone" })),
                    onDelete: removeDataPointValue
                })}
                density={"compact"}
                pageSize={20}
                rowsPerPageOptions={[20]}
                rowKey={dataPointValue => dataPointValue.id}
                components={{
                    // Toolbar: CustomToolbar,
                    Toolbar: AddFiltersExportToolbar,
                    Footer: CustomFooter,
                }}
                componentsProps={{
                    toolbar: {
                        handleAdd: handleAdd
                    }
                }}
            />}
            <CrudSnackbar/>
        </div>

    );

    // ****************** END RETURN ****************************

}


